import { useTranslation } from 'react-i18next'
import { SearchX } from 'lucide-react'
import { getLandingUrl } from '@/utils/tenant'

interface Props {
  host: string
}

/**
 * 등록되지 않은 센터 서브도메인으로 들어왔을 때 보여 주는 화면.
 * 로그인 화면을 그대로 보여 주면 없는 센터에서 로그인한 뒤 센터 API가 모두 실패한다(2026-11-02 운영 알람).
 */
export default function TenantNotFoundPage({ host }: Props) {
  const { t } = useTranslation('common')

  return (
    <main className="flex min-h-screen items-center justify-center bg-lc-bg-primary px-4">
      <div className="w-full max-w-md text-center">
        <SearchX className="mx-auto size-12 text-lc-text-secondary" aria-hidden />
        <h1 className="mt-4 text-pretty text-lc-v3-h2 font-bold text-lc-text-primary">
          {t('tenantNotFound.title')}
        </h1>
        <p className="mt-3 text-pretty break-all text-lc-v3-body-1 font-medium text-lc-text-secondary">
          {t('tenantNotFound.description', { host })}
        </p>
        <a
          href={getLandingUrl()}
          className="mt-8 inline-flex h-12 w-full items-center justify-center rounded-xl bg-lc-key-500 text-lc-v3-body-1 font-semibold text-lc-text-on-key hover:bg-lc-key-600"
        >
          {t('tenantNotFound.goHome')}
        </a>
      </div>
    </main>
  )
}
